export default "__VITE_ASSET__Cg9SnmKn__"